import React, { useEffect } from "react"
import { ArrowRight } from "lucide-react"
import { track } from "../analytics/mixpanel"
import { ErrorBoundary } from "./ErrorBoundary"
import { ThemeProvider } from "./landing/ThemeProvider"
import { LangProvider, useLang } from "./landing/i18n/LangContext"
import { SiteNav } from "./landing/SiteNav"
import { FeaturesSection } from "./landing/FeaturesSection"
import { UpcomingSection } from "./landing/UpcomingSection"
import { FinalCta } from "./landing/FinalCta"
import { SiteFooter } from "./landing/SiteFooter"

function Header() {
  const { t } = useLang()

  return (
    <header className="mx-auto max-w-3xl px-4 sm:px-6 pt-16 pb-4 text-center">
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 dark:text-white text-balance">
        {t.featuresPage.heading}
      </h1>
      <p className="mt-4 text-lg text-gray-500 dark:text-gray-400 text-pretty">
        {t.featuresPage.subheading}
      </p>
      <a
        href="/users/sign_up"
        className="mt-8 inline-flex items-center justify-center gap-2 rounded-lg bg-brand-600 px-6 py-3.5 text-sm sm:text-base font-semibold text-white hover:bg-brand-700 dark:bg-brand-500 dark:hover:bg-brand-600 active:scale-95 transition-all"
      >
        {t.hero.cta} <ArrowRight className="h-4 w-4" />
      </a>
    </header>
  )
}

export default function FeaturesApp({ logoUrl, signedIn }) {
  useEffect(() => {
    track("Features Page Viewed", { path: window.location.pathname })
  }, [])

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LangProvider>
          <div className="min-h-screen bg-white dark:bg-gray-950 antialiased">
            <SiteNav logoUrl={logoUrl} signedIn={signedIn} />
            <main>
              <Header />
              <FeaturesSection />
              <UpcomingSection />
              <FinalCta />
            </main>
            <SiteFooter logoUrl={logoUrl} />
          </div>
        </LangProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
